package org.example.project.model

data class PlacedShip(
    val type: ShipType,
    val row: Int,
    val col: Int,
    val horizontal: Boolean
)